import React from 'react';
import { Box, Flex, Spinner, Text } from '@chakra-ui/react';

const InitialView = ({ isLoading }) => (
  <>
    {isLoading ? (
      <Spinner size="xl" />
    ) : (
      <Box pt={5}>
        <Flex direction="column" align="center" justify="center" p={4} textAlign="center">
          {/* <Heading mb={4}>Customer Search</Heading> */}
          <Text mb={2}>Enter email or phone number to find a customer.</Text>
          <Text mb={2}>Or</Text>
          <Text mb={2}>
            Click on <b>'Create New Customer'</b> to create a customer.
          </Text>
        </Flex>
      </Box>
    )}
  </>
);

export default InitialView;
